import { render, staticRenderFns } from "./workplans.vue?vue&type=template&id=24c18f64&scoped=true"
import script from "./workplans.vue?vue&type=script&lang=ts"
export * from "./workplans.vue?vue&type=script&lang=ts"
import style0 from "./workplans.vue?vue&type=style&index=0&id=24c18f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c18f64",
  null
  
)

export default component.exports